import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { ConversationsOverview } from './conversations-overview'
import { RecentChats } from './recent-chats'
import type {
  MonthlyConversationsDTO,
  RecentAttendancesDTO,
} from '../types'

interface DashboardOverviewProps {
  monthlyConversations: MonthlyConversationsDTO
  recentAttendances: RecentAttendancesDTO
}

export function DashboardOverview({
  monthlyConversations,
  recentAttendances,
}: DashboardOverviewProps) {
  return (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-7'>
      <div className='col-span-1 lg:col-span-4'>
        <Card>
          <CardHeader>
            <CardTitle>{monthlyConversations.title}</CardTitle>
            <CardDescription>
              {monthlyConversations.description}
            </CardDescription>
          </CardHeader>
          <CardContent className='pl-2'>
            <ConversationsOverview data={monthlyConversations.data} />
          </CardContent>
        </Card>
      </div>

      <div className='col-span-1 lg:col-span-3'>
        <Card>
          <CardHeader>
            <CardTitle>{recentAttendances.title}</CardTitle>
            <CardDescription>
              Você teve {recentAttendances.total_this_month} atendimentos este
              mês
            </CardDescription>
          </CardHeader>
          <CardContent>
            <RecentChats attendances={recentAttendances.attendances} />
          </CardContent>
        </Card>
      </div>
    </div>
  )
} 